<td class="table-body__cell" role="rowheader">
  <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
    @if (company.inset) {
      <div class="tree-node-spacer"></div>
    }
    @for (visible of company.lines; track $index; let i = $index) {
      <div class="tree-node-inner"></div>
    }
    <div class="tw-flex tw-items-center tw-gap-4">
      @if (company.level < 0) {
        <streamline-icon aria-hidden="true" class="tw-mr-2 tw-flex-row" name="ellipsis" width="14" height="14"></streamline-icon>
      }
      @if (company.hasSubs) {
        <button mat-icon-button
          [attr.aria-label]="company.showSubs ? 'Hide subcompanies' : 'Show subcompanies'"
          [attr.aria-expanded]="company.showSubs"
          (click)="company.showSubs = !company.showSubs">
          <mat-icon [svgIcon]="company.showSubs ? 'chevron-down' : 'chevron-right'"></mat-icon>
        </button>
      }@else if (!root) {
        <div class="tw-w-16">&nbsp;</div>
      }
      <initials-badge [name]="company.name" [size]="32"></initials-badge>
      @if (root) {
        <p class="list-group-item-text">{{ company.name }}</p>
      }
      @else {
        <button type="button" class="madero-link subcompany-link font-weight-bold u_clickable flex-grow u_ellipsis tw-border-none focus:tw-outline-2 focus:tw-outline-blue-500 focus:tw-outline-offset-2" 
          (click)="selectCompany.emit(company.id)"
          [attr.aria-label]="'Select company ' + company.name">
          {{company.name}}
        </button>
      }
    </div>
  </div>
</td>
<td class="table-body__cell">
  <mat-form-field color="accent" appearance="outline" subscriptSizing="dynamic" style="width: 150px;">
    <mat-select
      [name]="'license-type-' + company.id"
      [ngModel]="companyAllocationService.getLicenseType(company)"
      (selectionChange)="allocateType($event.value)"
      [disabled]="companyAllocationService.getLicenseType(company) === 'managed' || !companyAllocationService.licenseAllocationEnabled">
      <mat-option value="">None</mat-option>
      <mat-option value="enterprise">Per-Display</mat-option>
      @if (companyStateService.isK12Customer()) {
        <mat-option value="unlimited">Unlimited</mat-option>
      }
      @if (companyAllocationService.getLicenseType(company) === 'managed') {
        <mat-option value="managed">Self-Managed</mat-option>
      }
      @if (!companyAllocationService.licenseAllocationEnabled) {
        <mat-option value="shared">Shared</mat-option>
      }
    </mat-select>
  </mat-form-field>
</td>
<td class="table-body__cell align-center">
  <number-input
    [value]="companyAllocationService.getLicenseType(company) === 'shared' ? 0 : company.allocatedLicenseCount"
    [name]="'license-count-' + company.id"
    [ariaLabel]="'Licenses allocated for ' + company.name"
    (updateValue)="updateCount($event)"
    [disabled]="companyAllocationService.getLicenseType(company) !== 'enterprise'"
    [min]="companyAllocationService.getLicenseType(company) === 'enterprise' ? 1 : 0"
    step="1">
  </number-input>
</td>
<td class="table-body__cell tw-text-end tw-text-gray-500">{{company.displayCount || 0}}</td>
